export const data = [
    {
        "state": "Karnataka",
        "cities": [
          {
            "name": "Badami",
            "population": 150000,
            "total_assets": 800000000,
            "asset_allocation": {
              "Historical_Sites": 300000000,
              "Infrastructure": 150000000,
              "Education": 100000000,
              "Healthcare": 100000000,
              "Public_Services": 150000000
            }
          },
          {
            "name": "Ballari",
            "population": 350000,
            "total_assets": 1200000000,
            "asset_allocation": {
              "Mining_Industry": 500000000,
              "Education": 200000000,
              "Healthcare": 150000000,
              "Housing": 200000000,
              "Public_Services": 150000000
            }
          },
          {
            "name": "Bengaluru",
            "population": 8500000,
            "total_assets": 50000000000,
            "asset_allocation": {
              "IT_Hub": 30000000000,
              "Infrastructure": 8000000000,
              "Education": 5000000000,
              "Healthcare": 4000000000,
              "Public_Services": 3000000000
            }
          },
          {
            "name": "Belagavi",
            "population": 700000,
            "total_assets": 2500000000,
            "asset_allocation": {
              "Industrial_Zones": 1000000000,
              "Education": 500000000,
              "Healthcare": 400000000,
              "Housing": 300000000,
              "Public_Services": 300000000
            }
          },
          {
            "name": "Bhadravati",
            "population": 200000,
            "total_assets": 1000000000,
            "asset_allocation": {
              "Steel_Industry": 400000000,
              "Education": 200000000,
              "Healthcare": 150000000,
              "Housing": 150000000,
              "Public_Services": 100000000
            }
          }
        ]
    },
      
    {
    "state": "Rajasthan",
    "cities": [
        {
        "name": "Ajmer",
        "population": 600000,
        "total_assets": 3000000000,
        "asset_allocation": {
            "Historical_Sites": 1000000000,
            "Commercial_Areas": 500000000,
            "Education": 500000000,
            "Healthcare": 400000000,
            "Public_Services": 500000000
        }
        },
        {
        "name": "Alwar",
        "population": 800000,
        "total_assets": 4000000000,
        "asset_allocation": {
            "Industrial_Zones": 1500000000,
            "Education": 800000000,
            "Healthcare": 700000000,
            "Housing": 500000000,
            "Public_Services": 500000000
        }
        },
        {
        "name": "Amer",
        "population": 150000,
        "total_assets": 1200000000,
        "asset_allocation": {
            "Cultural_Heritage": 400000000,
            "Education": 200000000,
            "Healthcare": 200000000,
            "Housing": 200000000,
            "Public_Services": 200000000
        }
        },
        {
        "name": "Barmer",
        "population": 400000,
        "total_assets": 2000000000,
        "asset_allocation": {
            "Mining_Industry": 800000000,
            "Education": 400000000,
            "Healthcare": 500000000,
            "Housing": 300000000,
            "Public_Services": 200000000
        }
        },
        {
        "name": "Beawar",
        "population": 300000,
        "total_assets": 1500000000,
        "asset_allocation": {
            "Industrial_Zones": 600000000,
            "Education": 300000000,
            "Healthcare": 300000000,
            "Housing": 300000000,
            "Public_Services": 200000000
        }
        }
    ]
    },
    {
    "state": "Tamil Nadu",
    "cities": [
        {
        "name": "Arcot",
        "population": 150000,
        "total_assets": 800000000,
        "asset_allocation": {
            "Historical_Sites": 300000000,
            "Commercial_Areas": 200000000,
            "Education": 100000000,
            "Healthcare": 150000000,
            "Public_Services": 150000000
        }
        },
        {
        "name": "Chengalpattu",
        "population": 500000,
        "total_assets": 2500000000,
        "asset_allocation": {
            "Industrial_Zones": 1000000000,
            "Education": 500000000,
            "Healthcare": 500000000,
            "Housing": 300000000,
            "Public_Services": 300000000
        }
        },
        {
        "name": "Chennai",
        "population": 8000000,
        "total_assets": 50000000000,
        "asset_allocation": {
            "IT_Hub": 30000000000,
            "Infrastructure": 8000000000,
            "Education": 5000000000,
            "Healthcare": 4000000000,
            "Public_Services": 2000000000
        }
        },
        {
        "name": "Chidambaram",
        "population": 100000,
        "total_assets": 600000000,
        "asset_allocation": {
            "Cultural_Heritage": 200000000,
            "Education": 100000000,
            "Healthcare": 150000000,
            "Housing": 100000000,
            "Public_Services": 150000000
        }
        },
        {
        "name": "Coimbatore",
        "population": 1200000,
        "total_assets": 7000000000,
        "asset_allocation": {
            "Industrial_Hub": 3000000000,
            "Education": 1500000000,
            "Healthcare": 1000000000,
            "Housing": 800000000,
            "Public_Services": 700000000
        }
        }
    ]
    },
      
    {
    "state": "Telangana",
    "cities": [
        {
        "name": "Hyderabad",
        "population": 9000000,
        "total_assets": 50000000000,
        "asset_allocation": {
            "IT_Hub": 30000000000,
            "Infrastructure": 8000000000,
            "Education": 5000000000,
            "Healthcare": 4000000000,
            "Public_Services": 2000000000
        }
        },
        {
        "name": "Karimnagar",
        "population": 300000,
        "total_assets": 1500000000,
        "asset_allocation": {
            "Education_Hub": 500000000,
            "Small_Industries": 200000000,
            "Healthcare": 300000000,
            "Housing": 300000000,
            "Public_Services": 200000000
        }
        },
        {
        "name": "Khammam",
        "population": 400000,
        "total_assets": 2000000000,
        "asset_allocation": {
            "Industrial_Zones": 800000000,
            "Education": 500000000,
            "Healthcare": 400000000,
            "Housing": 200000000,
            "Public_Services": 1000000000
        }
        },
        {
        "name": "Mahbubnagar",
        "population": 500000,
        "total_assets": 2500000000,
        "asset_allocation": {
            "Agriculture": 1000000000,
            "Education": 500000000,
            "Healthcare": 400000000,
            "Housing": 300000000,
            "Public_Services": 300000000
        }
        },
        {
        "name": "Nizamabad",
        "population": 600000,
        "total_assets": 3000000000,
        "asset_allocation": {
            "Agriculture": 1200000000,
            "Education": 500000000,
            "Healthcare": 500000000,
            "Housing": 400000000,
            "Public_Services": 300000000
        }
        }
    ]
    },
    {
    "state": "West Bengal",
    "cities": [
        {
        "name": "Alipore",
        "population": 200000,
        "total_assets": 1000000000,
        "asset_allocation": {
            "Residential_District": 300000000,
            "Commercial_Areas": 200000000,
            "Education": 100000000,
            "Healthcare": 150000000,
            "Public_Services": 250000000
        }
        },
        {
        "name": "Alipur Duar",
        "population": 150000,
        "total_assets": 800000000,
        "asset_allocation": {
            "Eco-Tourism": 300000000,
            "Infrastructure": 100000000,
            "Education": 150000000,
            "Healthcare": 150000000,
            "Public_Services": 100000000
        }
        },
        {
        "name": "Asansol",
        "population": 700000,
        "total_assets": 4000000000,
        "asset_allocation": {
            "Industrial_Zones": 1500000000,
            "Education": 500000000,
            "Healthcare": 800000000,
            "Housing": 500000000,
            "Public_Services": 500000000
        }
        },
        {
        "name": "Baharampur",
        "population": 300000,
        "total_assets": 1500000000,
        "asset_allocation": {
            "Historical_Sites": 500000000,
            "Agriculture": 300000000,
            "Education": 300000000,
            "Healthcare": 300000000,
            "Public_Services": 200000000
        }
        },
        {
        "name": "Bally",
        "population": 250000,
        "total_assets": 1200000000,
        "asset_allocation": {
            "Residential_Areas": 500000000,
            "Commercial_District": 300000000,
            "Education": 150000000,
            "Healthcare": 100000000,
            "Public_Services": 150000000
        }
        }
    ]
    },
      
    {
    "state": "Uttar Pradesh",
    "cities": [
        {
        "name": "Agra",
        "population": 1600000,
        "total_assets": 8000000000,
        "asset_allocation": {
            "Historical_Sites": 3000000000,
            "Infrastructure": 1500000000,
            "Education": 1000000000,
            "Healthcare": 1000000000,
            "Public_Services": 1500000000
        }
        },
        {
        "name": "Aligarh",
        "population": 900000,
        "total_assets": 4000000000,
        "asset_allocation": {
            "Educational_Hub": 1500000000,
            "Small_Industries": 800000000,
            "Healthcare": 600000000,
            "Housing": 500000000,
            "Public_Services": 500000000
        }
        },
        {
        "name": "Amroha",
        "population": 400000,
        "total_assets": 2000000000,
        "asset_allocation": {
            "Agriculture": 800000000,
            "Small_Industries": 300000000,
            "Education": 500000000,
            "Healthcare": 200000000,
            "Public_Services": 200000000
        }
        },
        {
        "name": "Ayodhya",
        "population": 700000,
        "total_assets": 3500000000,
        "asset_allocation": {
            "Religious_Tourism": 1500000000,
            "Infrastructure": 500000000,
            "Education": 500000000,
            "Healthcare": 500000000,
            "Public_Services": 500000000
        }
        },
        {
        "name": "Azamgarh",
        "population": 800000,
        "total_assets": 3000000000,
        "asset_allocation": {
            "Agriculture": 1000000000,
            "Education": 800000000,
            "Healthcare": 600000000,
            "Housing": 500000000,
            "Public_Services": 500000000
        }
        }
    ]
    },
      
    {
    "state": "Maharashtra",
    "cities": [
        {
        "name": "Mumbai",
        "population": 12000000,
        "total_assets": 60000000000,
        "asset_allocation": {
            "Financial_Hub": 30000000000,
            "Infrastructure": 15000000000,
            "Education": 5000000000,
            "Healthcare": 4000000000,
            "Public_Services": 2000000000
        }
        },
        {
        "name": "Nagpur",
        "population": 2500000,
        "total_assets": 12000000000,
        "asset_allocation": {
            "Industrial_Zones": 5000000000,
            "Education": 2000000000,
            "Healthcare": 1500000000,
            "Housing": 1500000000,
            "Public_Services": 1000000000
        }
        },
        {
        "name": "Nanded",
        "population": 600000,
        "total_assets": 3000000000,
        "asset_allocation": {
            "Agriculture": 1000000000,
            "Education": 800000000,
            "Healthcare": 500000000,
            "Housing": 500000000,
            "Public_Services": 200000000
        }
        },
        {
        "name": "Nashik",
        "population": 1500000,
        "total_assets": 8000000000,
        "asset_allocation": {
            "Wine_Industry": 3000000000,
            "Education": 1500000000,
            "Healthcare": 1500000000,
            "Housing": 1000000000,
            "Public_Services": 1000000000
        }
        },
        {
        "name": "Osmanabad",
        "population": 400000,
        "total_assets": 2000000000,
        "asset_allocation": {
            "Agriculture": 800000000,
            "Education": 500000000,
            "Healthcare": 400000000,
            "Housing": 200000000,
            "Public_Services": 300000000
        }
        }
    ]
    },  
    {
    "state": "Punjab",
    "cities": [
        {
        "name": "Amritsar",
        "population": 1200000,
        "total_assets": 8000000000,
        "asset_allocation": {
            "Historical_Sites": 3000000000,
            "Infrastructure": 1500000000,
            "Education": 1000000000,
            "Healthcare": 800000000,
            "Public_Services": 500000000
        }
        },
        {
        "name": "Batala",
        "population": 150000,
        "total_assets": 600000000,
        "asset_allocation": {
            "Small_Industries": 200000000,
            "Education": 100000000,
            "Healthcare": 150000000,
            "Housing": 100000000,
            "Public_Services": 50000000
        }
        },
        {
        "name": "Chandigarh",
        "population": 1100000,
        "total_assets": 15000000000,
        "asset_allocation": {
            "Administrative_Capital": 8000000000,
            "Infrastructure": 2500000000,
            "Education": 2000000000,
            "Healthcare": 1500000000,
            "Public_Services": 1000000000
        }
        },
        {
        "name": "Faridkot",
        "population": 200000,
        "total_assets": 1000000000,
        "asset_allocation": {
            "Agriculture": 400000000,
            "Education": 200000000,
            "Healthcare": 150000000,
            "Housing": 150000000,
            "Public_Services": 100000000
        }
        },
        {
        "name": "Firozpur",
        "population": 350000,
        "total_assets": 2000000000,
        "asset_allocation": {
            "Agriculture": 800000000,
            "Education": 500000000,
            "Healthcare": 400000000,
            "Housing": 150000000,
            "Public_Services": 150000000
        }
        }
    ]
    },
    {
        "state": "Gujarat",
        "cities": [
          {
            "name": "Ahmedabad",
            "population": 7000000,
            "total_assets": 10000000000,
            "asset_allocation": {
              "Infrastructure": 3000000000,
              "Education": 1500000000,
              "Healthcare": 2000000000,
              "Housing": 1200000000,
              "Public_Services": 1800000000
            }
          },
          {
            "name": "Amreli",
            "population": 300000,
            "total_assets": 500000000,
            "asset_allocation": {
              "Agriculture": 150000000,
              "Small_Industries": 100000000,
              "Education": 50000000,
              "Healthcare": 80000000,
              "Public_Services": 120000000
            }
          },
          {
            "name": "Bharuch",
            "population": 600000,
            "total_assets": 2500000000,
            "asset_allocation": {
              "Industrial_Zones": 1000000000,
              "Port_Development": 500000000,
              "Education": 300000000,
              "Housing": 200000000,
              "Public_Services": 500000000
            }
          },
          {
            "name": "Bhavnagar",
            "population": 700000,
            "total_assets": 1800000000,
            "asset_allocation": {
              "Maritime_Infrastructure": 800000000,
              "Tourism_Development": 300000000,
              "Education": 200000000,
              "Healthcare": 150000000,
              "Public_Services": 350000000
            }
          },
          {
            "name": "Bhuj",
            "population": 400000,
            "total_assets": 1200000000,
            "asset_allocation": {
              "Reconstruction_and_Development": 600000000,
              "Tourism_Promotion": 150000000,
              "Education": 120000000,
              "Healthcare": 180000000,
              "Public_Services": 150000000
            }
          },
          
        ]
    },
      
    {
        "state": "Haryana",
        "cities": [
          {
            "name": "Gurugram",
            "population": 2000000,
            "total_assets": 12000000000,
            "asset_allocation": {
              "IT_Hub": 5000000000,
              "Infrastructure": 2000000000,
              "Education": 1500000000,
              "Healthcare": 1000000000,
              "Public_Services": 500000000
            }
          },
          {
            "name": "Hansi",
            "population": 150000,
            "total_assets": 800000000,
            "asset_allocation": {
              "Agriculture": 300000000,
              "Small_Industries": 100000000,
              "Education": 150000000,
              "Healthcare": 150000000,
              "Public_Services": 100000000
            }
          },
          {
            "name": "Hisar",
            "population": 400000,
            "total_assets": 2000000000,
            "asset_allocation": {
              "Agricultural_Research": 800000000,
              "Education": 500000000,
              "Healthcare": 400000000,
              "Housing": 150000000,
              "Public_Services": 200000000
            }
          },
          {
            "name": "Jind",
            "population": 300000,
            "total_assets": 1500000000,
            "asset_allocation": {
              "Agriculture": 600000000,
              "Small_Industries": 200000000,
              "Education": 300000000,
              "Healthcare": 200000000,
              "Public_Services": 200000000
            }
          },
          {
            "name": "Kaithal",
            "population": 200000,
            "total_assets": 1000000000,
            "asset_allocation": {
              "Agriculture": 400000000,
              "Education": 200000000,
              "Healthcare": 150000000,
              "Housing": 100000000,
              "Public_Services": 150000000
            }
          }
        ]
    },
      
    {
        "state": "Madhya Pradesh",
        "cities": [
          {
            "name": "Balaghat",
            "population": 120000,
            "total_assets": 600000000,
            "asset_allocation": {
              "Mining": 200000000,
              "Education": 100000000,
              "Healthcare": 150000000,
              "Housing": 100000000,
              "Public_Services": 50000000
            }
          },
          {
            "name": "Barwani",
            "population": 80000,
            "total_assets": 400000000,
            "asset_allocation": {
              "Agriculture": 150000000,
              "Small_Industries": 50000000,
              "Education": 80000000,
              "Healthcare": 80000000,
              "Public_Services": 50000000
            }
          },
          {
            "name": "Betul",
            "population": 150000,
            "total_assets": 800000000,
            "asset_allocation": {
              "Agriculture": 300000000,
              "Education": 150000000,
              "Healthcare": 150000000,
              "Housing": 100000000,
              "Public_Services": 100000000
            }
          },
          {
            "name": "Bharhut",
            "population": 60000,
            "total_assets": 300000000,
            "asset_allocation": {
              "Cultural_Heritage": 100000000,
              "Education": 50000000,
              "Healthcare": 80000000,
              "Housing": 30000000,
              "Public_Services": 40000000
            }
          },
          {
            "name": "Bhind",
            "population": 200000,
            "total_assets": 1200000000,
            "asset_allocation": {
              "Agriculture": 500000000,
              "Education": 200000000,
              "Healthcare": 200000000,
              "Housing": 200000000,
              "Public_Services": 100000000
            }
          }
        ]
    }
      
  ];
  